import { render, staticRenderFns } from "./OptionalAccommodationExtrasCard.vue?vue&type=template&id=45cd0fd4&"
import script from "./OptionalAccommodationExtrasCard.vue?vue&type=script&lang=js&"
export * from "./OptionalAccommodationExtrasCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports